import { Injectable } from '@angular/core';
import * as math from 'mathjs'
import { QuestionnaireService } from './questionnaire.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomScoringService {
  public scoreDetailsList = [];
  responseValueType: any;
  scoreResponseType: any;
  scoreResponseListType: any;
  public responseValueTypeSet = new BehaviorSubject<any>(null);
  public responseValueTypeSetCast = this.responseValueTypeSet.asObservable()
  constructor(
    private qService: QuestionnaireService,

  ) {
    this.getResponseValueType();
  }

  getResponseValueType() {
    this.qService.getResponseValueType().subscribe((res: any) => {
      this.responseValueType = res?.Data?.responseValueTypes;
      this.responseValueTypeSet.next(this.responseValueType)
      this.scoreResponseType = this.responseValueType?.filter((element) => element.name === "Score")[0]?.responseValueTypeID; //9
      this.scoreResponseListType = this.responseValueType?.filter((element) => element.name === "Score Response List")[0]?.responseValueTypeID; //9
    });
  }

  public getScoreDetails(questionCategories, score, assessmentNumber) {
    if (score.responseValueTypeID === 10) {
      let equation = score.scoreDetailList[0]?.scoreDetails.toString();
      let scoreData = {
        equation: score.scoreDetailList[0]?.scoreDetails.toString(),
        itemId: score.itemID,
        value: "-",
        calculated: false

      };
      questionCategories?.forEach(question => {
        question?.versionItems.forEach(version => {
          version?.assesments.forEach(assessment => {
            if (assessment.assessmentID == assessmentNumber && assessment.itemId !== null) {
              if (equation.includes('(ItemId:' + assessment?.itemId?.toString() + ')') || equation.includes('(ItemId?:' + assessment?.itemId?.toString() + ')')) {
                let itemID = assessment?.itemId?.toString();
                let value = (assessment?.value != null && assessment?.value != undefined) ? assessment?.value?.toString() : '-';
                let optionalValue = value == '-' ? 0 : value;
                equation = equation?.replaceAll('(ItemId:' + itemID + ')', 'value:' + value);
                equation = equation?.replaceAll('(ItemId?:' + itemID + ')', 'value:' + optionalValue);
              }
            }
          });
        });
      });
      if (!equation.includes('value:-') && !equation?.includes('ItemId:') && !equation?.includes('undefined')) {
        equation = equation.replaceAll('value:', '');
        scoreData.value = this.calculateScore(equation).toFixed(2);
      }
      return scoreData;
    }
    else if (score.responseValueTypeID === 11) {
      let equation = score.scoreDetailList;
      let scoreData = {
        equation: score.scoreDetailList,
        itemId: score.itemID,
        calculated: false,
        value: "-",
        isForChildItem: score.isForChildItem
      };
      equation.forEach((item, index) => {
        item.eq = item.scoreDetails;
        item.itemId = score.itemID;
        questionCategories?.forEach(question => {
          question?.versionItems.forEach(version => {
            version?.assesments.forEach(assessment => {
              if (assessment.assessmentID == assessmentNumber && assessment.itemId !== null) {
                if (item?.eq?.includes('(ItemId:' + assessment?.itemId?.toString() + ')') || item?.eq?.includes('(ItemId?:' + assessment?.itemId?.toString() + ')')) {
                  let itemID = assessment?.itemId?.toString();
                  let value = (assessment?.value != null && assessment?.value != undefined) ? assessment?.value?.toString() : '-';
                  let optionalValue = value == '-' ? 0 : value;
                  item.eq = item.eq?.replaceAll('(ItemId:' + itemID + ')', 'value:' + value);
                  item.eq = item.eq?.replaceAll('(ItemId?:' + itemID + ')', 'value:' + optionalValue);
                }
              }
            });
          });
        });
      });
      equation.forEach((item) => {
        if (!item.eq?.includes('value:-') && !item.eq?.includes('ItemId:') && !item.eq?.includes('ItemId?:') && !item.eq?.includes('undefined')) {
          item.eq = item.eq?.replaceAll('value:', '');
          item.value = this.calculateScore(item.eq);
          scoreData.calculated = true;
        } else {
          item.value = false;
          scoreData.calculated = true;
        }
      });
      scoreData.equation = equation;
      return scoreData;
    }
  }

  public calculateScore(equation) {
    let parsedEquation = math.parse(equation);
    let compiledEquation = parsedEquation?.compile();
    let finalAnswer = compiledEquation?.evaluate();
    return finalAnswer;
  }
}
